import { HTMLAttributes } from "react";
import NokPrice from "@teamscheme/nok-price";
import { Switch, Route } from "react-router-dom";
import Page, { PageContent } from "../../formatting/Page";
import { PageCardContent } from "../../formatting/PageCard";
import Card from "../../formatting/Card";
import Products from "./Products";
import GetPayment from "./GetPayment";
import styled from "styled-components";
import { MembershipProduct } from "../PaymentViewModel";
import { onDesktop } from "../../shared/layout/Breakpoints";
import { ReactNode } from "react";

export interface ProductInfoProps
  extends Omit<HTMLAttributes<HTMLDivElement>, "children"> {
  product: MembershipProduct;
}

const PriceWrapper = styled.div`
  font-weight: normal;
  font-size: 1.5em;
`;

export const ProductInfo = styled(({ product, ...props }: ProductInfoProps) => (
  <div {...props}>
    <div>{product.name} i 12 måneder</div>
    <PriceWrapper>
      <NokPrice value={product.price} />
    </PriceWrapper>
  </div>
))`
  margin-bottom: 2em;

  ${onDesktop`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  `}
`;

function PaymentPageCard({ children }: { children: ReactNode }) {
  return (
    <PageContent>
      <Card>
        <PageCardContent>{children}</PageCardContent>
      </Card>
    </PageContent>
  );
}

const PaymentPage = styled(Page)``;

const PaymentRoutes = () => (
  <PaymentPage>
    <PaymentPageCard>
      <Switch>
        <Route path="/payment/:payment/:signature" component={GetPayment} />
        <Route component={Products} />
      </Switch>
    </PaymentPageCard>
  </PaymentPage>
);

export default PaymentRoutes;
